import Image from "@/components/Image";
import type { FC } from "react";

export const CommentAuthorSection: FC<{
  author: {
    imageUrl: string | null;
    emoji: string | null;
    username: string | null;
    firstName: string | null;
  };
}> = ({ author }) => {
  return (
    <div className="flex items-center gap-3">
      {author.imageUrl ? (
        <div className="relative h-8 w-8 overflow-hidden rounded-full">
          <Image
            src={author.imageUrl}
            alt={"User Image"}
            sizes="5rem"
            fill
            className="object-cover"
          />
        </div>
      ) : (
        <div className="bg-accent flex h-8 w-8 items-center justify-center rounded-full text-3xl">
          {<p>{author.emoji ? author.emoji : "😀"}</p>}
        </div>
      )}
      <div>
        <p className="text-base leading-tight">
          {author.firstName ??
            (author.username !== null ? `@${author.username}` : "")}
        </p>
      </div>
    </div>
  );
};
